import React, { useEffect, useState } from "react";
import { motion, animate } from "framer-motion";

const testimonials = [
  {
    text: `Thank you HTB family for all of the hard work and countless hours 
           that have gone into developing the premier content in HTB Academy. 
           I am grateful to have an affordable training resource that is helping 
           to fill the gap between what we are taught in school and what will 
           actually be required of us in the field.`,
    author: "@jhillman - Learner",
  },
  {
    text: `Hack The Box is where my infosec journey started. The main question 
           people usually have is “Where do I begin?”. At NVISO, we provide new 
           team members access to the HTB Academy, in which they complete modules 
           and follow tracks focused on a specific topic (e.g. AD, Web Pentesting, 
           Cryptography, etc.). This way, new NVISO-members build a strong 
           knowledge base in these subjects.`,
    author: "Firat Acar - Cybersecurity Consultant/Red Teamer",
  },
  {
    text: `We immediately started using HTB Academy after we signed up and found 
           that the modules challenge the students to work hard to successfully 
           reach an end goal. Now, we have students getting hired only a month 
           after starting to use HTB! We’re excited to see this trend continue 
           the rest of the academic year.`,
    author: "Matthew McCullough - Lead Instructor",
  },
];

export default function Reviews() {
  const [paths, setPaths] = useState(0);
  const [modules, setModules] = useState(0);
  const [labs, setLabs] = useState(0);
  const [current, setCurrent] = useState(0);

  // Animated counters
  useEffect(() => {
    animate(1, 15, {
      duration: 2,
      onUpdate(value) {
        setPaths(Math.floor(value));
      },
    });
    animate(1, 140, {
      duration: 2.5,
      onUpdate(value) {
        setModules(Math.floor(value));
      },
    });
    animate(1, 115, {
      duration: 3,
      onUpdate(value) {
        setLabs(Math.floor(value));
      },
    });
  }, []);

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextTestimonial = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prevTestimonial = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <div className="bg-gradient-to-br from-blue-950 via-red-900 to-blue-950 text-white min-h-screen py-16 px-6 text-center">
      {/* === Header === */}
      <div className="mb-10">
        <div className="text-3xl mb-2">⭐⭐⭐</div>
        <h2 className="text-3xl md:text-4xl font-bold text-red-400">
          50k+ 5 Star Reviews
        </h2>
      </div>

      {/* === Stats Section === */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12">
        <motion.div
          whileHover={{ scale: 1.05 }}
          className="p-6 rounded-2xl border border-blue-700 bg-blue-950/60 hover:bg-blue-900/80 transition"
        >
          <h3 className="text-3xl font-bold text-red-400 mb-1">{paths}+</h3>
          <p className="text-gray-300 text-sm">paths to obtain skill or job proficiency</p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          className="p-6 rounded-2xl border border-blue-700 bg-blue-950/60 hover:bg-blue-900/80 transition"
        >
          <h3 className="text-3xl font-bold text-red-400 mb-1">{modules}+</h3>
          <p className="text-gray-300 text-sm">modules from a diverse pool of instructors</p>
        </motion.div>

        <motion.div
          whileHover={{ scale: 1.05 }}
          className="p-6 rounded-2xl border border-blue-700 bg-blue-950/60 hover:bg-blue-900/80 transition"
        >
          <h3 className="text-3xl font-bold text-red-400 mb-1">{labs}+</h3>
          <p className="text-gray-300 text-sm">labs to obtain hands-on experience</p>
        </motion.div>
      </div>

      {/* === Testimonial Carousel === */}
      <div className="relative max-w-3xl mx-auto mb-8">
        <motion.div
          key={current}
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -50 }}
          transition={{ duration: 0.6 }}
          className="bg-blue-950/60 border border-red-600 rounded-2xl p-8 text-gray-200 shadow-lg"
        >
          <p className="text-base md:text-lg leading-relaxed">{testimonials[current].text}</p>
          <span className="block mt-4 text-sm text-blue-300">
            {testimonials[current].author}
          </span>
        </motion.div>

        {/* Controls */}
        <div className="flex justify-center items-center gap-4 mt-6">
          <button
            onClick={prevTestimonial}
            className="px-3 py-2 bg-red-600/30 hover:bg-red-600 text-white rounded-lg transition"
          >
            &lt;
          </button>
          <div className="flex gap-2">
            {testimonials.map((_, index) => (
              <span
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-3 h-3 rounded-full cursor-pointer transition ${
                  index === current ? "bg-red-500" : "bg-blue-700"
                }`}
              ></span>
            ))}
          </div>
          <button
            onClick={nextTestimonial}
            className="px-3 py-2 bg-red-600/30 hover:bg-red-600 text-white rounded-lg transition"
          >
            &gt;
          </button>
        </div>
      </div>

      {/* === Read More Link === */}
      <a
        href="#"
        className="inline-block text-red-400 hover:text-blue-400 font-semibold transition"
      >
        Read more Academy testimonials →
      </a>
    </div>
  );
}
